module.exports = __webpack_public_path__ + "static/media/SWSCRC1-22.d2a3b514.mp3";